import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router";
import { router } from "./app/router";
import { UpdatePrompt } from "./components/UpdatePrompt";
import { startInstallCapture } from "./lib/installPrompt";
import { startOfflineSync } from "./lib/offlineSync";
import { SessionProvider } from "./lib/session";
import "./styles/index.css";

const root = document.getElementById("root");
if (!root) throw new Error("#root is missing from index.html");

/**
 * Top-level wrapper. `UpdatePrompt` lives outside the router so it survives route changes. The session wraps
 * everything so the route guards and the 401 handler share one signed-in user.
 */
function App() {
  return (
    <SessionProvider>
      <RouterProvider router={router} />
      <UpdatePrompt />
    </SessionProvider>
  );
}

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

/* Drafts written offline go out the moment there is a connection, including after a reopen. */
startOfflineSync();

/* The browser offers its install prompt once, early: catch it before the hub asks. */
startInstallCapture();
